import { render, staticRenderFns } from "./scroll-messages.vue?vue&type=template&id=2144a75b&scoped=true&"
import script from "./scroll-messages.vue?vue&type=script&lang=js&"
export * from "./scroll-messages.vue?vue&type=script&lang=js&"
import style0 from "./scroll-messages.vue?vue&type=style&index=0&id=2144a75b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144a75b",
  null
  
)

export default component.exports